import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Input } from 'reactstrap';
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';

const AthKeycardGA = (props) => {
    const [selectList, setSelectList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [tableReady, setTableReady] = useState(false);
    const [searchboxValue, setSearchboxValue] = useState("");
    const [studentSelect, setStudentSelect] = useState();
    const [sportSelect, setSportSelect] = useState();
    const [sortBy, setSortBy] = useState(true);
    const dispatch = useDispatch()
    const selectAuthToken = state => state.apiKey
    const selectStore = state => state
    const authToken = useSelector(selectAuthToken);
    const reduxData = useSelector(selectStore);

    useEffect(() => {
        apiFetch("GetGATable", {}, setTableData)
    }, [])

    function apiFetch(url, body, stateItem) {
        let bearerVAR = "Bearer " + authToken
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            ...body
        }
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { stateItem(responseJSON) })
            .then((responseFollowup) => {
                if (url == "GetGATable") {
                    setTableReady(true);
                }
            })
    }

    function searchStudent() {
        if (searchboxValue != "") {
            apiFetch("GetGASearchData", { searchstring: searchboxValue }, setSelectList)
        }
    }

    function submitNewGA(e) {
        e.preventDefault();
        apiFetch("AddGA", { student: studentSelect, sport: sportSelect }, setTableData)
    }

    return (
        <div>
            <h2>GAs</h2><br />
                <div className="inlineCustom">
                <Input type="text" name="search" id="search" value={searchboxValue} onChange={e => setSearchboxValue(e.target.value)} onBlur={() => searchStudent()} /><p />
            </div>
            &emsp;&emsp;
            <div className="inlineCustom">
                    <Input type="select" name="student" id="student" value={studentSelect} onChange={e => setStudentSelect(e.target.value)}>
                        {selectList.length == 0 && <option value="BLANK" selected disabled>Search for a student</option>}
                    {selectList.length > 0 && <option value="BLANK" selected disabled>Select Student...</option> }
                        {selectList.map(item => (
                            <option value={item.pcid}>{item.studentname}</option>
                            )) }
                </Input>
            </div>
                &emsp;&emsp;
            <div className="inlineCustom">
                    <Input type="select" name="sport" id="sport" value={sportSelect} onChange={e => setSportSelect(e.target.value)}>
                        <option disabled selected value="BLANK">Select Sport...</option>
                        {props.sportsList.map(item => (
                            <option value={item.sportcode}>{item.sportname}</option>
                            )) }
                </Input>
            </div>
            &emsp;&emsp;
            <Button onClick={(e) => submitNewGA(e)} outline color="success">Add</Button>
            <p />
            {tableReady && <Table>
                <thead>
                    <tr>
                        <th>Student &emsp;<Input type="checkbox" name="namesort" id="namesort" checked={sortBy} onClick={(e) => setSortBy(e.target.checked) } /></th>
                        <th>Sport&emsp;<Input type="checkbox" name="sportsort" id="sportsort" checked={!sortBy} onClick={(e) => setSortBy(!e.target.checked) } /></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {sortBy && tableData
                        .sort(function (x, y) {
                        return x.student.toUpperCase() == y.student.toUpperCase() ? 0 : x.student.toUpperCase() > y.student.toUpperCase() ? 1 : -1;
                        }
                    )
                        .map(item => (
                        <tr>
                            <td>{item.student}</td>
                            <td>{item.sport}</td>
                                <td><Button outline color="danger" onClick={() => apiFetch("RemoveGA", {targetpk: item.pk}, setTableData) }>Delete</Button></td>
                        </tr>
                        ))}
                    {!sortBy && tableData
                        .sort(function (x, y) {
                            let a = x.sport.substring(3).toUpperCase()
                            let b = y.sport.substring(3).toUpperCase()
                            return a == b ? 0 : a > b ? 1 : -1;
                        })
                        .map(item => (
                            <tr>
                                <td>{item.student}</td>
                                <td>{item.sport}</td>
                                <td><Button outline color="danger" onClick={() => apiFetch("RemoveGA", { targetpk: item.pk }, setTableData)}>Delete</Button></td>
                            </tr>
                        ))}
                </tbody>
            </Table>}
        </div>
        );
}

export default AthKeycardGA;